import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getDynaWebTabs() {
  const data = await apiGet('helper/dybaWebTabs');
  useHelperStore().setDynaWebTabs(data);
}
